<template>
  <r-form ref="rform" class="page" classContent="page-content full-height" :itemId="id" @save="onSave" :readonly="readonly" :dbAdapter="Tarifa"
    :default-data="{formulaTPC:'', formulaTPO:'', formulaPrecio:'', porcSegunda:0, factorTiempoCampo2:0, factorTiempoOficina2:0, campos:[], subtipos:[], versiones:[], servicioIds:[], materiaIds:[], documentos:[]}">
    <template v-slot:before="{rform}">
      <f7-navbar>
        <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
        <f7-nav-title v-if="id && !readonly" sliding>{{$t('tarifas.editar')}}</f7-nav-title>
        <f7-nav-title v-else-if="id" sliding>{{$t('tarifas.ver')}}</f7-nav-title>
        <f7-nav-title v-else sliding>{{$t('tarifas.nuevo')}}</f7-nav-title>
        <f7-nav-right>
          <f7-button v-if="!readonly" fill icon-f7="floppy_disk" text="Guardar" @click="rform.saveItem()"/><f7-button v-if="id && !readonly" color="green" @click="cambiarEstado('activar')">{{$t('tarifas.activar')}}</f7-button>
          <f7-button v-if="id && !readonly" color="red" @click="cambiarEstado('anular')">{{$t('tarifas.anular')}}</f7-button>
        </f7-nav-right>
      </f7-navbar>
    </template>

    <template v-slot:default="{rform}">
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-content>
          <f7-row no-gap class="list list-form" style="z-index: 12;">
            <r-input class="col-100 medium-20" floating-label :label="$t('tarifas.codigo')" :form="rform" type="text" name="codigo" required></r-input>
            <r-input class="col-100 medium-40" floating-label :label="$t('tarifas.nombre')" :form="rform" type="text" name="nombre" required></r-input>
            <r-input class="col-100 medium-40" floating-label :label="$t('tarifas.familia')" :form="rform" type="select" name="familia">
              <option value="ELECTRICO">Eléctrico</option>
              <option value="MECANICO">Mecánico</option>
              <option value="TERMICO">Térmico</option>
              <option value="PRESION">Presión</option>
              <option value="PETROLIFERAS">Petrolíferas</option>
              <option value="INCENDIOS">Incendios</option>
              <option value="MAQUINAS">Máquinas</option>
              <option value="OTROS">Otros</option>
            </r-input>
          </f7-row>
          <f7-row no-gap class="list list-form">
            <r-input class="col-100" floating-label :label="$t('tarifas.descripcion')" :form="rform" type="textarea" name="descripcion"></r-input>
          </f7-row>
          <f7-row no-gap class="list list-form separacion">
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.formulaTPC')" :form="rform" type="text" name="formulaTPC"></r-input>
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.formulaTPO')" :form="rform" type="text" name="formulaTPO"></r-input>
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.formulaPrecio')" :form="rform" type="text" name="formulaPrecio"></r-input>
          </f7-row>
          <f7-row no-gap class="list list-form separacion">
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.porcSegunda')" :form="rform" type="number" step="0.01" name="porcSegunda"></r-input>
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.factorTiempoCampo2')" :form="rform" type="number" step="0.01" name="factorTiempoCampo2"></r-input>
            <r-input class="col-100 medium-33" floating-label :label="$t('tarifas.factorTiempoOficina2')" :form="rform" type="number" step="0.01" name="factorTiempoOficina2"></r-input>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- Seccion VERSIONADO -->
      <f7-card v-if="id && rform.formData" class="padding-vertical-half padding-right">
        <div class="ver-ch">VERSIONADO</div>
        <f7-card-content>
          <div class="ver-grid">
            <div class="ver-item"><span class="ver-label">Version</span><span class="ver-value">v.{{ herramientaInfo ? herramientaInfo.version : (rform.formData.versionActual || 1) }}</span></div>
            <div class="ver-item">
              <span class="ver-label">Fecha Desde</span>
              <span class="ver-value">{{ herramientaInfo ? formatFechaVer(herramientaInfo.fechaDesde) : (ultimaVersion ? formatFechaVer(ultimaVersion.fecha) : '—') }}</span>
            </div>
            <div class="ver-item">
              <span class="ver-label">Fecha Hasta</span>
              <span class="ver-value" :class="(herramientaInfo && !herramientaInfo.fechaHasta) || rform.formData.estado === 'VIGENTE' ? 'ver-vigente' : ''">
                {{ herramientaInfo ? (herramientaInfo.fechaHasta ? formatFechaVer(herramientaInfo.fechaHasta) : 'Vigente') : (rform.formData.estado === 'VIGENTE' ? 'Vigente' : '—') }}
              </span>
            </div>
            <div class="ver-item" v-if="herramientaInfo && herramientaInfo.configGlobalVersion"><span class="ver-label">Config Global</span><span class="ver-value">v.{{ herramientaInfo.configGlobalVersion }}</span></div>
            <div class="ver-item" v-if="herramientaInfo && herramientaInfo.modificadoPor"><span class="ver-label">Modificado por</span><span class="ver-value">{{ herramientaInfo.modificadoPor }}</span></div>
            <div class="ver-item" v-else-if="ultimaVersion && ultimaVersion.usuario"><span class="ver-label">Modificado por</span><span class="ver-value">{{ ultimaVersion.usuario }}</span></div>
            <div class="ver-item" v-if="herramientaInfo && herramientaInfo.motivo"><span class="ver-label">Motivo</span><span class="ver-value">{{ herramientaInfo.motivo }}</span></div>
            <div class="ver-item" v-else-if="ultimaVersion && ultimaVersion.descripcionCambio"><span class="ver-label">Motivo</span><span class="ver-value">{{ ultimaVersion.descripcionCambio }}</span></div>
          </div>
        </f7-card-content>
      </f7-card>

      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header>
          <b>{{ $t('tarifas.camposEntrada') }}</b>
          <f7-button v-if="!readonly" fill small color="green" @click="addCampo(rform)">
            <f7-icon f7="plus" size="16"></f7-icon> {{ $t('tarifas.addCampo') }}
          </f7-button>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!rform.formData.campos || !rform.formData.campos.length" class="text-color-gray padding">
            {{ $t('tarifas.sinCampos') }}
          </div>
          <div v-for="(campo, idx) in rform.formData.campos" :key="idx" class="campo-row">
            <f7-row no-gap class="align-items-center">
              <f7-col width="100" medium="15">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoClave')"
                    type="text"
                    :value="campo.clave"
                    @input="campo.clave = $event.target.value"
                    :readonly="readonly"
                    required
                  ></f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col width="100" medium="20">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoEtiqueta')"
                    type="text"
                    :value="campo.etiqueta"
                    @input="campo.etiqueta = $event.target.value"
                    :readonly="readonly"
                    required
                  ></f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col width="100" medium="15">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoTipo')"
                    type="select"
                    :value="campo.tipo"
                    @change="campo.tipo = $event.target.value"
                    :readonly="readonly"
                  >
                    <option value="NUMERICO">Numérico</option>
                    <option value="TEXTO">Texto</option>
                    <option value="BOOLEANO">Booleano</option>
                    <option value="SELECCION">Selección</option>
                  </f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col width="100" medium="10">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoOrden')"
                    type="number"
                    :value="campo.orden"
                    @input="campo.orden = parseInt($event.target.value) || 0"
                    :readonly="readonly"
                  ></f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col width="100" medium="15">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoValorDefecto')"
                    type="text"
                    :value="campo.valorDefecto"
                    @input="campo.valorDefecto = $event.target.value"
                    :readonly="readonly"
                  ></f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col v-if="campo.tipo === 'SELECCION'" width="100" medium="15">
                <f7-list no-hairlines-md class="no-margin">
                  <f7-list-input
                    :label="$t('tarifas.campoOpciones')"
                    type="text"
                    :value="(campo.opciones || []).join(', ')"
                    @change="campo.opciones = $event.target.value.split(',').map(s => s.trim()).filter(s => s)"
                    :readonly="readonly"
                    :placeholder="$t('tarifas.opcionesPlaceholder')"
                  ></f7-list-input>
                </f7-list>
              </f7-col>
              <f7-col v-else width="100" medium="15"></f7-col>
              <f7-col width="100" medium="10" class="text-align-center">
                <f7-button v-if="!readonly" fill small color="red" @click="removeCampo(rform, idx)">
                  <f7-icon f7="trash" size="16"></f7-icon>
                </f7-button>
              </f7-col>
            </f7-row>
          </div>
        </f7-card-content>
      </f7-card>

      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header>
          <b>{{ $t('tarifas.subtipos') }}</b>
          <f7-button v-if="!readonly" fill small color="green" @click="addSubtipo(rform)">
            <f7-icon f7="plus" size="16"></f7-icon> {{ $t('tarifas.addSubtipo') }}
          </f7-button>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!rform.formData.subtipos || !rform.formData.subtipos.length" class="text-color-gray padding">
            {{ $t('tarifas.sinSubtipos') }}
          </div>
          <f7-list v-else accordion-list no-hairlines-md class="no-margin">
            <f7-list-item
              v-for="(subtipo, idx) in rform.formData.subtipos"
              :key="idx"
              accordion-item
              :title="(subtipo.codigo || $t('tarifas.subtipoCodigo')) + ' - ' + (subtipo.nombre || $t('tarifas.subtipoNombre'))"
            >
              <f7-accordion-content>
                <div class="subtipo-content">
                  <f7-row no-gap>
                    <f7-col width="100" medium="25">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.subtipoCodigo')"
                          type="text"
                          :value="subtipo.codigo"
                          @input="subtipo.codigo = $event.target.value"
                          :readonly="readonly"
                          required
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                    <f7-col width="100" medium="75">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.subtipoNombre')"
                          type="text"
                          :value="subtipo.nombre"
                          @input="subtipo.nombre = $event.target.value"
                          :readonly="readonly"
                          required
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                  </f7-row>
                  <f7-row no-gap>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.formulaTPC')"
                          type="text"
                          :value="subtipo.formulaTPC"
                          @input="subtipo.formulaTPC = $event.target.value"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.formulaTPO')"
                          type="text"
                          :value="subtipo.formulaTPO"
                          @input="subtipo.formulaTPO = $event.target.value"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.formulaPrecio')"
                          type="text"
                          :value="subtipo.formulaPrecio"
                          @input="subtipo.formulaPrecio = $event.target.value"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                  </f7-row>
                  <f7-row no-gap>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.porcSegunda')"
                          type="number"
                          step="0.01"
                          :value="subtipo.porcSegunda"
                          @input="subtipo.porcSegunda = parseFloat($event.target.value) || 0"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.factorTiempoCampo2')"
                          type="number"
                          step="0.01"
                          :value="subtipo.factorTiempoCampo2"
                          @input="subtipo.factorTiempoCampo2 = parseFloat($event.target.value) || 0"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                    <f7-col width="100" medium="33">
                      <f7-list no-hairlines-md class="no-margin">
                        <f7-list-input
                          :label="$t('tarifas.factorTiempoOficina2')"
                          type="number"
                          step="0.01"
                          :value="subtipo.factorTiempoOficina2"
                          @input="subtipo.factorTiempoOficina2 = parseFloat($event.target.value) || 0"
                          :readonly="readonly"
                        ></f7-list-input>
                      </f7-list>
                    </f7-col>
                  </f7-row>
                  <f7-row class="margin-top-half">
                    <f7-col class="text-align-right">
                      <f7-button v-if="!readonly" fill small color="red" @click="removeSubtipo(rform, idx)">
                        <f7-icon f7="trash" size="16"></f7-icon> {{ $t('common.eliminar') }}
                      </f7-button>
                    </f7-col>
                  </f7-row>
                </div>
              </f7-accordion-content>
            </f7-list-item>
          </f7-list>
        </f7-card-content>
      </f7-card>
    </template>
  </r-form>
</template>

<script>
import Tarifa from './../../js/db/Tarifa.js';
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";

export default {
  components: {
    rForm,
    rInput
  },
  props: {
    editable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      id: this.$f7route.params.id || null,
      readonly: !this.editable,
      Tarifa,
      herramientaInfo: null
    };
  },
  computed: {
    ultimaVersion: function() {
      if (!this.$refs.rform || !this.$refs.rform.formData || !this.$refs.rform.formData.versiones) return null;
      var v = this.$refs.rform.formData.versiones;
      if (!v.length) return null;
      return v.reduce(function(a, b) { return (a.numero || 0) > (b.numero || 0) ? a : b; });
    }
  },
  mounted: function() {
    this.cargarHerramientaInfo();
  },
  methods: {
    formatFechaVer: function(str) {
      if (!str) return '—';
      try { var d = new Date(str); return isNaN(d.getTime()) ? str : String(d.getDate()).padStart(2,'0')+'/'+String(d.getMonth()+1).padStart(2,'0')+'/'+d.getFullYear(); } catch(e) { return str; }
    },
    cargarHerramientaInfo: function() {
      var self = this;
      // Wait for rform to load, then match by codigo
      var check = function() {
        if (!self.$refs.rform || !self.$refs.rform.formData || !self.$refs.rform.formData.codigo) {
          setTimeout(check, 300);
          return;
        }
        var codigo = self.$refs.rform.formData.codigo;
        Tarifa.getHerramientas().then(function(res) {
          var list = res.list || res || [];
          var found = null;
          for (var i = 0; i < list.length; i++) {
            if (list[i].codigo === codigo) { found = list[i]; break; }
          }
          self.herramientaInfo = found;
        }).catch(function() { self.herramientaInfo = null; });
      };
      if (this.id) check();
    },
    onSave(res) {
      this.$f7.toast.create({ icon: '<i class="f7-icons">checkmark</i>', text: this.$t('common.guardado_ok'), position: 'center', closeTimeout: 1500 }).open();
      if (!this.id && res && res.id) {
        this.$f7.views.current.router.navigate(`/tarifas/edit/${res.id}/`);
      }
    },
    addCampo(rform) {
      if (!rform.formData.campos) {
        this.$set(rform.formData, 'campos', []);
      }
      rform.formData.campos.push({
        clave: '',
        etiqueta: '',
        tipo: 'NUMERICO',
        orden: rform.formData.campos.length + 1,
        valorDefecto: '',
        opciones: []
      });
    },
    removeCampo(rform, idx) {
      rform.formData.campos.splice(idx, 1);
    },
    addSubtipo(rform) {
      if (!rform.formData.subtipos) {
        this.$set(rform.formData, 'subtipos', []);
      }
      rform.formData.subtipos.push({
        codigo: '',
        nombre: '',
        formulaTPC: '',
        formulaTPO: '',
        formulaPrecio: '',
        porcSegunda: 0,
        factorTiempoCampo2: 0,
        factorTiempoOficina2: 0
      });
    },
    removeSubtipo(rform, idx) {
      rform.formData.subtipos.splice(idx, 1);
    },
    cambiarEstado(accion) {
      var self = this;
      var app = self.$f7;
      if (!self.id) {
        return;
      }
      var fn = accion === 'activar' ? Tarifa.activar.bind(Tarifa) : Tarifa.anular.bind(Tarifa);
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `finally` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      fn({ itemId: self.id })
        .then(() => {
          app.toast.create({ icon: '<i class="f7-icons">checkmark</i>', text: this.$t('common.operacion_ok'), position: 'center', closeTimeout: 1500 }).open();
          self.$refs.rform.reload();
        })
        .catch(e => app.dialog.alert(e.message || e))
        .finally(() => espera.cerrar());
    }
  }
};
</script>
<style scoped>
.campo-row { border-bottom: 1px solid #e0e0e0; padding: 0.3rem 0; }
.campo-row:last-child { border-bottom: none; }
.separacion { margin-top: 0.5rem; }
.subtipo-content { padding: 0.5rem 1rem; }
.ver-ch { padding:5px 8px; font-size:10px; font-weight:700; color:#fff; background:#1a2744; text-transform:uppercase; letter-spacing:.05em; }
.ver-grid { display:flex; gap:16px; flex-wrap:wrap; font-size:11px; color:#555; }
.ver-item { display:flex; flex-direction:column; gap:1px; }
.ver-label { font-size:9px; font-weight:700; color:#94a3b8; text-transform:uppercase; letter-spacing:.05em; }
.ver-value { font-size:12px; font-weight:600; color:#1e293b; }
.ver-vigente { color:#16a34a; }
</style>
